import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { post } from '../../Services/http';
import Checkbox from '../Inputs/Checkbox';
import { translate } from '../../Services/translation';
import 'react-datepicker/dist/react-datepicker.css';

const CustomDeliveryFields = () => {
  const [calendarStartDate, setCalendarStartDate] = useState(new Date()); // today
  const [preferredDeliveryDate, setPreferredDeliveryDate] =
    useState<Date>(calendarStartDate);
  const [isJointDelivery, setIsJointDelivery] = useState<boolean>(false);

  const onPreferredDeliveryDateChanged = (date: Date) => {
    return post('/api/checkoutcustomer/setdate', date);
  };

  const onIsJointDeliveryChanged = (isJointDelivery: boolean) => {
    return post('/api/checkoutcustomer/setjointdelivery', {
      isJointDelivery,
    });
  };

  const onCheckboxJointDelivery = (value) => {
    setIsJointDelivery(value);
    onIsJointDeliveryChanged(value);
  };

  const keyboardHandling = (e) => {
    e.preventDefault();
    return false;
  };

  useEffect(() => {
    const sendDateAndJointValues = async () => {
      await onPreferredDeliveryDateChanged(preferredDeliveryDate);
      await onIsJointDeliveryChanged(isJointDelivery);
    };

    sendDateAndJointValues();
  }, []);

  return (
    <>
      <div className="flex flex-col gap-2">
        <span className="text-lg font-bold">
          {translate('checkout.preferreddeliverydate')}
        </span>
        <DatePicker
          selected={calendarStartDate}
          onChange={(date) => setCalendarStartDate(date)}
          onSelect={(date) => {
            setPreferredDeliveryDate(date);
            onPreferredDeliveryDateChanged(date);
          }}
          minDate={calendarStartDate}
          disabledKeyboardNavigation
          onKeyDown={keyboardHandling}
          className="border border-gray-400 p-4"
        />
      </div>
      <div className="flex flex-col gap-2">
        <span className="text-lg font-bold">
          {translate('checkout.jointdelivery.header')}
        </span>
        <Checkbox
          inputSize="large"
          id="joint-delivery"
          checked={isJointDelivery}
          onChange={() => onCheckboxJointDelivery(!isJointDelivery)}
          label={translate(`checkout.jointdelivery.checkboxtext`)}
        />
      </div>
    </>
  );
};

export default CustomDeliveryFields;
